import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { apiNotificationsFetch } from '../index';
import {
  GetNotificationParams,
  INotificationServer,
  notificationFilter,
  NOTIFICATIONS_QUERY_KEYS,
} from './types';

export const _getAllNotifications = (params: GetNotificationParams = {}) => {
  const defaultParams: Required<GetNotificationParams> = {
    limit: 50,
    page: 1,
    filter: notificationFilter.NEW,
    search: '',
  };

  const mergedParams = { ...defaultParams, ...params };

  return queryOptions({
    queryKey: [NOTIFICATIONS_QUERY_KEYS.notifications, mergedParams],
    queryFn: () => apiNotificationsFetch<INotificationServer[]>('/', { params: mergedParams }),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};

export const _searchNotifications = (params: GetNotificationParams) => {
  const pageSize = 50;
  return infiniteQueryOptions({
    queryKey: [NOTIFICATIONS_QUERY_KEYS.notifications, 'search', params],
    initialPageParam: 1,
    enabled: Boolean(params.search?.trim()),
    queryFn: ({ pageParam }) =>
      apiNotificationsFetch<INotificationServer[]>('/', {
        params: { ...params, limit: pageSize, page: pageParam },
      }),
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.length === pageSize ? lastPageParam + 1 : undefined,
    refetchOnWindowFocus: false,
  });
};

export const _getNotificationsCount = () =>
  queryOptions({
    queryKey: [NOTIFICATIONS_QUERY_KEYS.notifications, 'count'],
    queryFn: () => apiNotificationsFetch<{ total: number; new: number }>('/count'),
    refetchOnWindowFocus: false,
  });
